export default __webpack_public_path__ + "static/media/Helm of the Blood Drinker.71947906.jpg";